import axios from "axios";
import { SERVER_URL } from "../socket";

export async function loadSliderImages() {
  const res = await axios.get(`${SERVER_URL}/api/login-slider/images`);
  return res.data?.images || [];
}

export async function loadAdminSliderImages(authHeaders) {
  const res = await axios.get(`${SERVER_URL}/api/admin/slider-images`, { headers: authHeaders });
  return res.data?.images || [];
}

export async function uploadSliderImage(file, authHeaders) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${SERVER_URL}/api/admin/slider-images/upload`, form, {
    headers: {
      ...authHeaders,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data?.image;
}

export async function updateSliderImage(id, payload, authHeaders) {
  const res = await axios.put(
    `${SERVER_URL}/api/admin/slider-images/${id}`,
    payload,
    { headers: authHeaders }
  );
  return res.data?.image;
}

export async function deleteSliderImage(id, authHeaders) {
  const res = await axios.delete(`${SERVER_URL}/api/admin/slider-images/${id}`, {
    headers: authHeaders,
  });
  return res.data;
}
